import React, { Component } from 'react';
import { APIProvider, Map } from '@vis.gl/react-google-maps';

import withAuthorization from '../components/withAuthorization';
import { auth } from '../firebase/index.js';
import { db, realtimeDb } from '../firebase/firebase';

import Modal from 'react-modal';
import { showSnackbar, showSnackbarWithType, showSnackbarWithTimeout } from '../components/Snackbar.js';
import { Table } from 'element-react';
import 'element-theme-default';
import RoleUtils from '../utils/RoleUtils';
import DrawingLayer from '../components/MapFeatures/DrawingLayer.js';

class MyWorkArea extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userData: null,
            workareas: null,
            selectedWorkarea: null,
            postcodeLabelText: '',
            showWerkgebiedenModal: false,
            showDrawWerkgebiedenModal: false,
            showDeleteWorkAreaModal: false,
            searchGemeenteText: '',
            filteredGemeenten: [],
            selectedGeometry: null,
            savedGeometries: [],
            tobeDeletedGeometries: [],
            defaultMapCenter: { lat: 0, lng: 0 }
        };

    }

    componentDidMount() {
        this.getMyWorkareas();

        showSnackbarWithTimeout('Gegevens laden..', 1000);
    }

    getMyWorkareas = async () => {
        const userData = await auth.getUserData();
        console.log(userData);
        this.setState({ userData, workareas: [], savedGeometries: [], defaultMapCenter: { lat: userData.preferredLocation ? userData.preferredLocation.u_ : 0, lng: userData.preferredLocation ? userData.preferredLocation.h_ : 0 } });
        const workareasRef = realtimeDb.ref(`/workareas/${userData.uid}`);

        workareasRef.on('value', (snapshot) => {
            let workareas = snapshot.val();
            console.log('Fetched workareas:', workareas);

            if (!workareas) {
                workareas = [];
            }
            const savedGeometries = workareas.filter(item => item.geometry);
            this.setState({ workareas, savedGeometries });
        });
    }

    componentWillUnmount() {

    }

    closeModal = () => {
        this.setState({ infoModalOpen: false, commentModalOpen: false });
    }

    savePostcodes = async (selectWorkArea) => {
        const userData = this.props.rootUserData;

        let newPostcodes = [...(this.state.workareas || [])];
        const existingGroup = newPostcodes.find(item => item.label === (selectWorkArea ? selectWorkArea.label : this.state.selectedWorkarea.label));

        if (selectWorkArea) {
            if (existingGroup) {
                existingGroup.postcodes = selectWorkArea.postcodes;
                newPostcodes = [...new Set([...newPostcodes, existingGroup])];
            } else {
                newPostcodes.push(selectWorkArea);
            }
        } else if (this.state.selectedWorkarea) {
            if (existingGroup) {
                existingGroup.postcodes = [...new Set([...existingGroup.postcodes, ...this.state.selectedWorkarea.postcodes])];
                newPostcodes = [...new Set([...newPostcodes, existingGroup])];
            } else {
                newPostcodes.push(this.state.selectedWorkarea);
            }
        }

        await realtimeDb.ref(`/workareas/${userData.uid}`).set(newPostcodes);
        showSnackbar('Opgeslagen', 'success');

        this.setState({ workareas: newPostcodes, selectedWorkarea: null, postcodeLabelText: '', showWerkgebiedenModal: false });
    }

    handleSearchGemeenteChange = (e) => {
        const results = gemeenten.filter(gemeente =>
            gemeente.label.toLowerCase().startsWith(e.target.value.toLowerCase())
        );
        this.setState({ searchGemeenteText: e.target.value, filteredGemeenten: results });
    }

    selectGemeente = (gemeente) => {
        this.setState({ searchGemeenteText: '', selectedWorkarea: { label: gemeente.label, postcodes: gemeente.postcodes }, postcodeLabelText: gemeente.label, filteredGemeenten: [] });
    }

    removeGeometry = (geo) => {
        const updatedGeometries = this.state.savedGeometries.filter(
            g => g.id !== geo.id
        );

        let tobeDeletedGeometries = this.state.tobeDeletedGeometries;
        tobeDeletedGeometries.push(geo);

        this.setState({
            savedGeometries: updatedGeometries,
            selectedGeometry: null,
            tobeDeletedGeometries
        });
    }

    render() {
        if (this.props.rootUserData && (!RoleUtils.hasRole(this.props.rootUserData, RoleUtils.Roles.Wijkagent) && !RoleUtils.hasRole(this.props.rootUserData, RoleUtils.Roles.Gemeente) && !RoleUtils.hasRole(this.props.rootUserData, RoleUtils.Roles.Administrator))) {
            return (
                <div className="container content">
                    <div className="alert alert-danger" role="alert">
                        Je hebt geen toegang tot deze pagina.
                    </div>
                </div>
            );
        }

        return (
            <div className="container workarea content">

                <h2>Mijn werkgebieden</h2>
                <span>Gebruik werkgebieden om eenvoudig en snel artikelen/alarmmeldingen aan te maken en te beheren.</span>
                <button className="btn btn-primary btn-raised" onClick={() => this.setState({ showWerkgebiedenModal: true, selectedWorkarea: null, postcodeLabelText: '' })}>+ Nieuw (Postcode)</button>
                <button className="btn btn-primary btn-raised" style={{ marginLeft: 12 }} onClick={() => this.setState({ showDrawWerkgebiedenModal: true, selectedWorkarea: null, postcodeLabelText: '' })}>+ Nieuw (Tekenen)</button>

                <Modal
                    className="Modal__Bootstrap modal-dialog modal-lg"
                    closeTimeoutMS={150}
                    shouldCloseOnOverlayClick={false}
                    shouldCloseOnEsc={false}
                    isOpen={this.state.showWerkgebiedenModal}
                    onRequestClose={() => this.setState({ showWerkgebiedenModal: false })}
                    ariaHideApp={false}
                >
                    {this.state.workareas && (
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title" style={{ marginRight: 10 }}>Werkgebied toevoegen (postcodes)</h4>
                                <button type="button" className="close" onClick={() => this.setState({ showWerkgebiedenModal: false, selectedWorkarea: null })}>
                                    <span aria-hidden="true">&times;</span>
                                    <span className="sr-only">Annuleren</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                {this.state.selectedWorkarea == null && (
                                    <div className="card" style={{ backgroundColor: '#f8f9fa', padding: '20px', borderRadius: '5px', marginBottom: 8 }}>
                                        <input
                                            type="text"
                                            placeholder="Zoeken op gemeente of plaats."
                                            onChange={(e) => this.handleSearchGemeenteChange(e)}
                                            value={this.state.searchGemeenteText}
                                            style={{ marginLeft: 10, background: 'white' }}
                                        />
                                        <div>
                                            {this.state.searchGemeenteText && (
                                                <ul style={{ marginTop: 6, marginBottom: 0 }}>
                                                    {this.state.filteredGemeenten.slice(0, 5).map(gemeente => (
                                                        <li key={gemeente.id} onClick={() => this.selectGemeente(gemeente)} style={{ cursor: 'pointer', marginBottom: 3, fontSize: 14 }}>
                                                            {this.state.searchGemeenteText && (
                                                                <span>
                                                                    <strong>{gemeente.label.substring(0, this.state.searchGemeenteText.length)}</strong>
                                                                    {gemeente.label.substring(this.state.searchGemeenteText.length)}
                                                                </span>
                                                            )}
                                                            <span key={gemeente.label} className="badge badge-default" style={{ marginLeft: '5px' }}>
                                                                {gemeente.postcodes.join(', ')}
                                                            </span>
                                                            <span style={{ marginLeft: '6px' }}> (Selecteren)</span>
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </div>
                                    </div>)}
                                <div className="werkgebied-form" style={{ backgroundColor: '#f8f9fa', padding: '20px', borderRadius: '5px' }}>
                                    {this.state.selectedWorkarea == null && (
                                        <p>Of voeg handmatig werkgebied toe</p>
                                    )}
                                    <div className="form-group">
                                        <label htmlFor="postcode">Label</label>
                                        <br />
                                        <input
                                            type="text"
                                            id="postcodeLabel"
                                            placeholder="Label (Bijv. Centrum)"
                                            onChange={(e) => this.setState({ postcodeLabelText: e.target.value })}
                                            value={this.state.postcodeLabelText}
                                            style={{ width: '100%' }}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="postcode">Postcode </label>
                                        <br />
                                        <input
                                            type="text"
                                            id="postcode"
                                            placeholder="1234AB (letters optioneel)"
                                            onChange={(e) => this.setState({ postcodeText: e.target.value })}
                                            value={this.state.postcodeText}
                                            style={{ width: '100%' }}
                                        />
                                    </div>
                                    <button
                                        className="btn btn-primary btn-raised"
                                        onClick={() => {
                                            if (!this.state.postcodeText) {
                                                return;
                                            }
                                            if (this.state.postcodeText.trim() !== '' && this.state.postcodeLabelText.trim() !== '') {
                                                let newWorkarea = [...(this.state.workareas || [])];
                                                const postcode = this.state.postcodeText;
                                                const existingGroup = newWorkarea.find(item => item.label === this.state.postcodeLabelText);

                                                if (this.state.postcodeLabelText) {
                                                    if (existingGroup) {
                                                        existingGroup.postcodes.push(postcode);
                                                    }
                                                } else {
                                                    showSnackbarWithType('Label niet ingevuld', 'error');
                                                    return;
                                                }


                                                this.setState({
                                                    selectedWorkarea: existingGroup ? existingGroup : {
                                                        label: this.state.postcodeLabelText,
                                                        postcodes: this.state.selectedWorkarea ? [...this.state.selectedWorkarea.postcodes, postcode] : [postcode]
                                                    },
                                                    postcodeText: '',
                                                });

                                            } else {
                                                showSnackbarWithType('Vul zowel label als postcode in.', 'error');
                                            }
                                        }}
                                    >
                                        Toevoegen
                                    </button>

                                    {this.state.selectedWorkarea && (
                                        <div className="werkgebieden-list">
                                            {this.state.selectedWorkarea.postcodes && (
                                                <ul className="list-group">
                                                    {this.state.selectedWorkarea.postcodes.map((item, index) => (
                                                        <li key={index} className="list-group-item d-flex justify-content-between align-items-center" style={{ padding: 0 }}>
                                                            <span key={index} className="badge badge-default" style={{ marginRight: '5px' }}>
                                                                {item}
                                                            </span>

                                                            <button
                                                                className="btn btn-danger btn-sm"
                                                                onClick={() => {
                                                                    const newPostcodes = this.state.selectedWorkarea.postcodes.filter((_, i) => i !== index);
                                                                    this.setState({
                                                                        selectedWorkarea: {
                                                                            label: this.state.selectedWorkarea.label,
                                                                            postcodes: newPostcodes
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                <i className="material-icons" title="Verwijderen" data-toggle="tooltip">delete_forever</i>
                                                            </button>
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </div>
                                    )}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => this.setState({ showWerkgebiedenModal: false })}>Sluiten</button>
                                    <button className="btn btn-primary btn-outline" onClick={() => this.savePostcodes(this.state.selectedWorkarea)}>Opslaan</button>
                                </div>
                            </div>
                        </div>
                    )}
                </Modal>

                <Modal
                    className="Modal__Bootstrap modal-dialog modal-lg"
                    closeTimeoutMS={150}
                    shouldCloseOnOverlayClick={false}
                    shouldCloseOnEsc={false}
                    isOpen={this.state.showDrawWerkgebiedenModal}
                    onRequestClose={() => this.setState({ showDrawWerkgebiedenModal: false })}
                    ariaHideApp={false}
                >
                    <div className="modal-content">
                        <div className="modal-header" style={{ alignItems: 'normal', justifyContent: 'normal' }}>
                            <h4 className="modal-title" style={{ width: "70%" }}>Werkgebieden (getekend)</h4>
                            <div className="modal-header-actions">
                                <button type="button" className="btn btn-secondary" style={{ marginRight: 6 }} onClick={() => this.setState({ showDrawWerkgebiedenModal: false, tobeDeletedGeometries: [] })}>Annuleren</button>
                                <button type="button" className="btn btn-primary btn-raised" onClick={async () => {
                                    let newWorkareas = [...(this.state.workareas || [])];

                                    const geometries = this.state.savedGeometries;


                                    for (const geom of geometries) {
                                        const existingGroup = newWorkareas.find(item => item.id === geom.id);

                                        if (existingGroup) {
                                            existingGroup.id = geom.id;
                                            existingGroup.label = geom.label;
                                            existingGroup.geometry = geom.geometry;
                                            existingGroup.color = geom.color;
                                            newWorkareas = [...new Set([...newWorkareas, existingGroup])];
                                        } else {
                                            newWorkareas.push({
                                                id: geom.id,
                                                label: geom.label,
                                                geometry: geom.geometry,
                                                color: geom.color
                                            });
                                        }
                                    }

                                    for (const geom of this.state.tobeDeletedGeometries) {
                                        const geomIndex = newWorkareas.findIndex(item => item.id === geom.id);
                                        if (geomIndex !== -1) {
                                            newWorkareas.splice(geomIndex, 1);
                                        }
                                    }

                                    const userData = this.props.rootUserData;
                                    await realtimeDb.ref(`/workareas/${userData.uid}`).set(newWorkareas);
                                    showSnackbar('Opgeslagen', 'success');

                                    this.setState({ workareas: newWorkareas, selectedWorkarea: null, postcodeLabelText: '', showDrawWerkgebiedenModal: false, selectedGeometry: null, savedGeometries: newWorkareas.filter(item => item.geometry) });
                                }}>Opslaan</button>
                            </div>
                        </div>
                        <div className="modal-body">
                            <div style={{ display: 'inline-block', width: '100%', position: 'relative', top: '-8px' }}>
                                <div style={{ backgroundColor: 'rgba(255, 255, 255, 0.8)', marginBottom: 6, marginLeft: 6 }}>
                                    <input type="text" placeholder="Naam werkgebied" value={this.state.selectedGeometry ? this.state.selectedGeometry.label : ''} onChange={(e) => this.setState({ selectedGeometry: { ...this.state.selectedGeometry, label: e.target.value } })} />
                                    <input type="color" style={{ position: 'relative', top: 3, marginLeft: 6 }} value={this.state.selectedGeometry ? this.state.selectedGeometry.color : ''} onChange={(e) => this.setState({ selectedGeometry: { ...this.state.selectedGeometry, color: e.target.value } })} />
                                    {this.state.selectedGeometry && (
                                        <button
                                            className="btn btn-danger btn-outline btn-sm"
                                            style={{ marginLeft: 10, padding: '5px 10px' }}
                                            onClick={() =>
                                                this.removeGeometry(this.state.selectedGeometry)
                                            }
                                        >
                                            Verwijder
                                        </button>
                                    )}
                                </div>
                                <span style={{ fontSize: '14px', fontWeight: 'bold', display: 'block', width: '100%', borderTop: '1px solid #ccc', paddingTop: 8, color: '#6c757d' }}>Legenda (kaart) knoppen: Slepen, Cirkel, Vierkant of Vrij tekenen</span>
                            </div>
                            {this.props.rootUserData && (
                                <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY} libraries={['drawing']}>
                                    <Map
                                        style={{ height: 500 }}
                                        mapId={"WerkgebiedMap"}
                                        defaultZoom={15}
                                        gestureHandling={'greedy'}
                                        disableDefaultUI={true}
                                        clickableIcons={false}
                                        defaultCenter={this.state.defaultMapCenter}
                                    >
                                        <DrawingLayer
                                            selectedGeometry={this.state.selectedGeometry}
                                            savedGeometries={this.state.savedGeometries}
                                            onGeometryComplete={(geometryData) => {
                                                // Add new geometry to saved list
                                                console.log('New geometry created:', geometryData);
                                                this.setState({
                                                    savedGeometries: [...this.state.savedGeometries, geometryData],
                                                    selectedGeometry: geometryData // Auto-select the new geometry
                                                });
                                            }}
                                            onGeometryUpdate={(geometryData) => {
                                                // Update existing geometry in saved list
                                                console.log('Geometry updated:', geometryData);
                                                const foundGeometry = this.state.savedGeometries.find(geo => geo.id === geometryData.id);
                                                if (foundGeometry) {
                                                    let updatedGeometries = [...this.state.savedGeometries];
                                                    updatedGeometries[updatedGeometries.indexOf(foundGeometry)] = geometryData;
                                                    this.setState({
                                                        savedGeometries: updatedGeometries
                                                    });
                                                }
                                            }}
                                            onGeometrySelect={(geometryData) => {
                                                // Handle geometry selection
                                                console.log('Geometry selected:', geometryData);
                                                this.setState({
                                                    selectedGeometry: geometryData
                                                });
                                            }}
                                        />
                                    </Map>
                                </APIProvider>
                            )}

                        </div>
                    </div>
                </Modal>

                <Modal
                    className="Modal__Bootstrap modal-dialog"
                    closeTimeoutMS={150}
                    isOpen={this.state.showDeleteWorkAreaModal}
                    onRequestClose={() => this.setState({ showDeleteWorkAreaModal: false })}
                    ariaHideApp={false}
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Werkgebied verwijderen</h4>
                            <button type="button" className="close" onClick={() => this.setState({ showDeleteWorkAreaModal: false })}>
                                <span aria-hidden="true">&times;</span>
                                <span className="sr-only">Annuleren</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <span>Weet je zeker dat je {this.state.selectedWorkarea ? this.state.selectedWorkarea.label : ''} wilt verwijderen?</span>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={() => this.setState({ showDeleteWorkAreaModal: false })}>Annuleren</button>
                            <button type="button" className="btn btn-danger btn-outline" onClick={async () => {
                                const newWorkareas = this.state.workareas.filter(item => item !== this.state.selectedWorkarea);
                                const userData = this.props.rootUserData;
                                await realtimeDb.ref(`/workareas/${userData.uid}`).set(newWorkareas);
                                this.setState({ workareas: newWorkareas, showDeleteWorkAreaModal: false, selectedWorkarea: null });
                            }}>Verwijderen</button>
                        </div>
                    </div>
                </Modal>

                <div className="card werkgebieden-list">
                    {this.state.workareas && this.state.workareas.length > 0 ? (
                        <ul className="list-group" style={{ marginLeft: 6 }}>
                            {this.state.workareas.map((item, index) => (
                                <li key={index} className="list-group-item d-flex justify-content-between align-items-center" style={{ padding: 0 }}>
                                    <span>{item.label && item.label + ":"} {item.postcodes && item.postcodes.map((code, index) => (
                                        <span key={index} className="badge badge-primary" style={{ marginRight: '5px' }}>
                                            {code}
                                        </span>
                                    ))}
                                        {(item.geometry && item.color) && (
                                            <span className="badge badge-default" style={{ marginLeft: '5px', backgroundColor: item.color }}>
                                                Getekend
                                            </span>
                                        )}
                                    </span>
                                    <div>
                                        <button
                                            className="btn btn-primary btn-sm"
                                            onClick={() => {
                                                if (item.geometry) {
                                                    const typeGeo = item.geometry.type;
                                                    let calcCenter = { lat: 0, lng: 0 };

                                                    if (typeGeo == "rectangle") {
                                                        calcCenter = {
                                                            lat: (item.geometry.bounds.north + item.geometry.bounds.south) / 2,
                                                            lng: (item.geometry.bounds.east + item.geometry.bounds.west) / 2
                                                        };
                                                    } else if (typeGeo == "polygon") {
                                                        let center = this.calculateCentroid(item.geometry.coordinates);
                                                        calcCenter = center;
                                                    } else if (typeGeo == "circle") {
                                                        calcCenter = { lat: item.geometry.center.lat, lng: item.geometry.center.lng };
                                                    }
                                                    this.setState({ showDrawWerkgebiedenModal: true, selectedWorkarea: null, postcodeLabelText: '', defaultMapCenter: calcCenter });
                                                } else {
                                                    this.setState({ showWerkgebiedenModal: true, selectedWorkarea: item, postcodeLabelText: item.label });
                                                }
                                            }}>
                                            <i className="material-icons" title="Bewerken" data-toggle="tooltip">edit</i>
                                        </button>
                                        <button
                                            className="btn btn-danger btn-sm"
                                            onClick={() => {
                                                this.setState({ showDeleteWorkAreaModal: true, selectedWorkarea: item })
                                            }}
                                        >
                                            <i className="material-icons" title="Verwijderen" data-toggle="tooltip">delete_forever</i>
                                        </button>
                                    </div>

                                </li>
                            ))}
                        </ul>
                    ) : (
                        <p style={{ marginLeft: 6 }}>Geen werkgebieden gevonden.</p>
                    )}
                </div>

            </div>
        );
    }

    calculateCentroid(coordinates) {
        const sumLng = coordinates.reduce((sum, point) => sum + point.lng, 0);
        const sumLat = coordinates.reduce((sum, point) => sum + point.lat, 0);

        return {
            lng: sumLng / coordinates.length,
            lat: sumLat / coordinates.length
        };
    }

    closeModal = () => {
        this.setState({ infoModalOpen: false, commentModalOpen: false });
    }
}

const authCondition = (authUser) => !!authUser;

export default withAuthorization(authCondition)(MyWorkArea);

const gemeenten = [
    { label: "Aadorp", postcodes: ["7611"] },
    { label: "Aagtdorp", postcodes: ["1871"] },
    { label: "Aagtekerke", postcodes: ["2774"] },
    { label: "Aalbeek", postcodes: ["6336"] },
    { label: "Aalden", postcodes: ["7854"] },
    { label: "Aaldonk", postcodes: ["6595"] },
    { label: "Aalsmeer", postcodes: ["1430", "1431", "1432", "1433"] },
    { label: "Aalst (Buren)", postcodes: ["4033"] },
    { label: "Aalst (Noord-Brabant)", postcodes: ["5582", "5583"] },
    { label: "Aalst (Zaltbommel)", postcodes: ["5308"] },
    { label: "Aalsum (Friesland)", postcodes: ["9121"] },
    { label: "Aalsum (Westerkwartier)", postcodes: ["9883"] },
    { label: "Aam", postcodes: ["7120", "7121", "7122", "7123"] },
    { label: "Aan de Zuwe", postcodes: ["3648"] },
    { label: "Aan het Broek", postcodes: ["6093"] },
    { label: "Aardenburg", postcodes: ["4527"] },
    { label: "Aarlanderveen", postcodes: ["2445"] },
    { label: "Aarle (Best)", postcodes: ["5684"] },
    { label: "Aarle-Rixtel", postcodes: ["5735"] },
    { label: "Aartswoud", postcodes: ["1719"] },
    { label: "Abbega", postcodes: ["8617"] },
    { label: "Abbegaasterketting", postcodes: ["8617"] },
    { label: "Abbekerk", postcodes: ["1657"] },
    { label: "Abbenbroek", postcodes: ["3216"] },
    { label: "Abbenes", postcodes: ["2157"] },
    { label: "Abbengawier", postcodes: ["9011"] },
    { label: "Abbestede", postcodes: ["1759"] },
    { label: "Abbewier", postcodes: ["9133"] },
    { label: "Abcoude", postcodes: ["1390", "1391"] },
    { label: "Achlum", postcodes: ["8806"] },
    { label: "Acht (Eindhoven)", postcodes: ["5621", "5626"] },
    { label: "Achter het Klooster", postcodes: ["6093"] },
    { label: "Achter 't Hout", postcodes: ["9461"] },
    { label: "Achterberg (Utrecht)", postcodes: ["3911"] },
    { label: "Achterbos (De Ronde Venen)", postcodes: ["3645"] },
    { label: "Achterbroek (Zuid-Holland)", postcodes: ["2825"] },
    { label: "Achterdijk (Utrecht)", postcodes: ["4243"] },
    { label: "Achter-Drempt", postcodes: ["6996"] },
    { label: "Achtersloot (Utrecht)", postcodes: ["3401"] },
    { label: "Achterste Erm", postcodes: ["7843"] },
    { label: "Achterveld (Barneveld)", postcodes: ["3792"] },
    { label: "Achterveld (Leusden)", postcodes: ["3791"] },
    { label: "Achthoven (Montfoort)", postcodes: ["3417"] },
    { label: "Achthoven (Vijfheerenlanden)", postcodes: ["4128"] },
    { label: "Achthuizen", postcodes: ["3256"] },
    { label: "Achtmaal", postcodes: ["4885"] },
    { label: "Achttienhoven (Utrecht)", postcodes: ["3615"] },
    { label: "Acquoy", postcodes: ["4151"] },
    { label: "Adorp", postcodes: ["9774"] },
    { label: "Aduard", postcodes: ["9830", "9831"] },
    { label: "Aegum", postcodes: ["9006"] },
    { label: "Aerdenhout", postcodes: ["2111"] },
    { label: "Aerdt", postcodes: ["6913"] },
    { label: "Afferden (Gelderland)", postcodes: ["6654"] },
    { label: "Afferden (Limburg)", postcodes: ["5851"] },
    { label: "Aijen", postcodes: ["5854"] },
    { label: "Akersloot", postcodes: ["1920", "1921"] },
    { label: "Akkrum", postcodes: ["8491"] },
    { label: "Akmarijp", postcodes: ["8541"] },
    { label: "Albergen", postcodes: ["7665"] },
    { label: "Alblasserdam", postcodes: ["2950", "2951", "2952", "2953", "2954"] },
    { label: "Alem", postcodes: ["5335"] },
    { label: "Alkmaar", postcodes: ["1800", "1801", "1802", "1803", "1804", "1805", "1806", "1807", "1808", "1809", "1810", "1811", "1812", "1813", "1814", "1815", "1816", "1817", "1818", "1819", "1820", "1821", "1822", "1823", "1824", "1825", "1826", "1827"] },
    { label: "Allingawier", postcodes: ["8758"] },
    { label: "Almelo", postcodes: ["7600", "7601", "7602", "7603", "7604", "7605", "7606", "7607", "7608", "7609", "7610", "7611", "7612", "7613", "7614", "7627"] },
    { label: "Almen", postcodes: ["7218"] },
    {
        label: "Almere", postcodes: [
            "1300", "1301", "1302", "1303", "1304", "1305", "1306", "1307", "1308", "1309",
            "1310", "1311", "1312", "1313", "1314", "1315", "1316", "1317", "1318", "1319",
            "1320", "1321", "1322", "1323", "1324", "1325", "1326", "1327", "1328", "1329",
            "1330", "1331", "1332", "1333", "1334", "1335", "1336", "1337", "1338", "1339",
            "1340", "1341", "1342", "1343", "1344", "1345", "1346", "1347", "1348", "1349",
            "1350", "1351", "1352", "1353", "1354", "1355", "1356", "1357", "1358", "1359",
            "1360", "1361", "1362", "1363", "1364", "1365", "1366", "1367", "1368", "1369",
            "1370", "1371", "1372", "1373", "1374", "1375", "1376", "1377", "1378", "1379"
        ]
    },
    { label: "Almkerk", postcodes: ["4286"] },
    { label: "Alphen aan den Rijn (plaats)", postcodes: ["2401", "2402", "2403", "2404", "2405", "2406", "2407", "2408", "2409"] },
    { label: "Alphen (Gelderland)", postcodes: ["6626"] },
    { label: "Alphen (Noord-Brabant)", postcodes: ["5130", "5131"] },
    { label: "Altena (Drenthe)", postcodes: ["9321"] },
    { label: "Alteveer (De Wolden)", postcodes: ["7927"] },
    { label: "Alteveer (Hoogeveen)", postcodes: ["7915"] },
    { label: "Alteveer (Noordenveld)", postcodes: ["9306"] },
    { label: "Alteveer (Stadskanaal)", postcodes: ["9661"] },
    { label: "Altforst", postcodes: ["6628"] },
    { label: "Altweerterheide", postcodes: ["6006"] },
    { label: "Alverna", postcodes: ["6603"] },
    { label: "Ameide (plaats)", postcodes: ["4233"] },
    { label: "Amen (Aa en Hunze)", postcodes: ["9446"] },
    { label: "America (Limburg)", postcodes: ["5966"] },
    { label: "Amerongen", postcodes: ["3958"] },
    {
        label: "Amersfoort", postcodes: [
            "3800", "3801", "3802", "3803", "3804", "3805", "3806", "3807", "3808", "3809",
            "3810", "3811", "3812", "3813", "3814", "3815", "3816", "3817", "3818", "3819",
            "3820", "3821", "3822", "3823", "3824", "3825", "3826", "3827", "3828", "3829"
        ]
    },
    { label: "Ammerstol", postcodes: ["2865"] },
    { label: "Ammerzoden", postcodes: ["5324"] },
    { label: "Amstelhoek", postcodes: ["1427"] },
    {
        label: "Amstelveen", postcodes: [
            "1180", "1181", "1182", "1183", "1184",
            "1185", "1186", "1187", "1188", "1189"
        ]
    },
    { label: "Amstenrade", postcodes: ["6436"] },
    {
        label: "Amsterdam", postcodes: [
            "1000", "1001", "1002", "1003", "1004", "1005", "1006", "1007", "1008", "1009",
            "1010", "1011", "1012", "1013", "1014", "1015", "1016", "1017", "1018", "1019",
            "1020", "1021", "1022", "1023", "1024", "1025", "1026", "1027", "1028", "1029",
            "1030", "1031", "1032", "1033", "1034", "1035", "1036", "1037", "1038", "1039",
            "1040", "1041", "1042", "1043", "1044", "1045", "1046", "1047", "1048", "1049",
            "1050", "1051", "1052", "1053", "1054", "1055", "1056", "1057", "1058", "1059",
            "1060", "1061", "1062", "1063", "1064", "1065", "1066", "1067", "1068", "1069",
            "1070", "1071", "1072", "1073", "1074", "1075", "1076", "1077", "1078", "1079",
            "1080", "1081", "1082", "1083", "1084", "1085", "1086", "1087", "1088", "1089",
            "1090", "1091", "1092", "1093", "1094", "1095", "1096", "1097", "1098", "1099",
            "1100", "1101", "1102", "1103", "1104", "1105", "1106", "1107", "1108", "1109",
            "1380", "1381", "1382", "1383", "1384"
        ]
    },
    { label: "Andel", postcodes: ["4281"] },
    { label: "Andelst", postcodes: ["6673"] },
    { label: "Anderen", postcodes: ["9465"] },
    { label: "Andijk", postcodes: ["1619"] },
    { label: "Angeren", postcodes: ["6687"] },
    { label: "Angerlo", postcodes: ["6986"] },
    { label: "Anjum", postcodes: ["9133"] },
    { label: "Ankeveen", postcodes: ["1244"] },
    { label: "Anloo", postcodes: ["9467"] },
    {
        label: "Anna Paulowna (plaats)", postcodes: [
            "1760", "1761", "1762", "1763", "1764", "1765", "1766"
        ]
    },
    { label: "Annen", postcodes: ["9468"] },
    { label: "Annerveenschekanaal", postcodes: ["9654"] },
    {
        label: "Apeldoorn (stad)", postcodes: [
            "7300", "7301", "7302", "7303", "7304", "7305", "7306", "7307", "7308", "7309",
            "7310", "7311", "7312", "7313", "7314", "7315", "7316", "7317", "7318", "7319",
            "7320", "7321", "7322", "7323", "7324", "7325", "7326", "7327", "7328", "7329",
            "7330", "7331", "7332", "7333", "7334", "7335", "7336", "7337", "7338", "7339"
        ]
    },
    { label: "Appelscha", postcodes: ["8426"] },
    { label: "Appeltern", postcodes: ["6629"] },
    { label: "Appingedam", postcodes: ["9900", "9901", "9902", "9903"] },
    { label: "Arcen", postcodes: ["5944"] },
    { label: "Arkel", postcodes: ["4241"] },
    { label: "Arkens", postcodes: ["8802"] },
    { label: "Arkum", postcodes: ["8765"] },
    { label: "Arnemuiden", postcodes: ["4340", "4341"] },
    {
        label: "Arnhem", postcodes: [
            "6800", "6801", "6802", "6803", "6804", "6805", "6806", "6807", "6808", "6809",
            "6810", "6811", "6812", "6813", "6814", "6815", "6816", "6817", "6818", "6819",
            "6820", "6821", "6822", "6823", "6824", "6825", "6826", "6827", "6828", "6829",
            "6830", "6831", "6832", "6833", "6834", "6835", "6836", "6837", "6838", "6839",
            "6840", "6841", "6842", "6843", "6844", "6845", "6846"
        ]
    },
    { label: "Arum (plaats)", postcodes: ["8822"] },
    { label: "Asbroek (Leudal)", postcodes: ["6088", "6089"] },
    { label: "Asch", postcodes: ["4115"] },
    { label: "Asenray", postcodes: ["6042"] },
    { label: "Asperen", postcodes: ["4147"] },
    { label: "Asschat", postcodes: ["3831"] },
    { label: "Asselt", postcodes: ["6071"] },
    {
        label: "Assen", postcodes: [
            "9400", "9401", "9402", "9403", "9404",
            "9405", "9406", "9407", "9408", "9409",
            "9486", "9487", "9488", "9489", "9492"
        ]
    },
    { label: "Assendelft", postcodes: ["1566", "1567"] },
    { label: "Asten (plaats)", postcodes: ["5720", "5721"] },
    { label: "Atzeburen", postcodes: ["8762"] },
    { label: "Augsbuurt", postcodes: ["9292"] },
    { label: "Augustinusga", postcodes: ["9284"] },
    { label: "Austerlitz", postcodes: ["3711"] },
    { label: "Avenhorn", postcodes: ["1633", "1648"] },
    { label: "Axel (plaats)", postcodes: ["4571"] },


    { label: "Waalwijk (plaats)", postcodes: ["5140", "5141", "5142", "5143", "5144", "5145", "5146"] },
    { label: "Waalwijk (gemeente)", postcodes: ["5140", "5141", "5142", "5143", "5144", "5145", "5146", "5160", "5161", "5162", "5163", "5164", "5165"] },
    { label: "Sprang-Capelle (plaats)", postcodes: ["5160", "5161"] },
    { label: "Kaatsheuvel (plaats)", postcodes: ["5170", "5171", "5172"] },
    { label: "Loon op Zand (gemeente)", postcodes: ["5170", "5171", "5172", "5175", "5176"] },
    { label: "Dongen (gemeente)", postcodes: ["5100", "5101", "5102", "5103", "5104", "5105", "5106", "5107"] },
    { label: "Waspik (plaats)", postcodes: ["5162", "5165",] },
];
